/**
 * This configuration defines a set of z-index values used across
 * the application to manage the stacking order of elements.
 */
export const zIndexes = {
    codeEditor: 1,
    tableSummary: 3,  // keep - z-index for tablesSummary is set in @src/components/UI/Table/overrides.css
    tablePagination: 4,
    cascadeButtons: 4,
    cardDragAndDropHandle: 5,
    tableHeader: 6, // keep - z-index for tableHeader is set in @src/components/UI/Table/overrides.css
    payoutFormulaWrapper: 10,
    tableTopBar: 11,
    headerMenu: 12,
};
